import React from "react";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";

import Button, { Color } from "Components/Form/Button";

const WrapperFooter = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
}));

interface DrawerFooterProps {
  isLoading: boolean;
  isDisabled: boolean;
  submit: () => void;
  onClose: () => void;
}

export function DrawerFooter(props: DrawerFooterProps) {
  const { t: translate } = useTranslation();
  const { isLoading = false, isDisabled = false, submit, onClose } = props;

  return (
    <WrapperFooter>
      <Button onClick={onClose}>{translate("close")}</Button>
      <Button
        disabled={isDisabled}
        customColor={Color.BRAND}
        onClick={submit}
        loading={isLoading}
      >
        {translate("generateAndDownload")}
      </Button>
    </WrapperFooter>
  )
}
